module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hres7fe-detail"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7FEC2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setYearOutput(_vm.searchIndex.year)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7FEC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.codcours) + " - " + _vm._s(_vm.indexSelected.desc_codcours))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7FEC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.numclseq))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('detail-tab1', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "codeval": _vm.codeval,
      "detailTab1": _vm.detail.tab1,
      "postHres7feTab1Save": _vm.postHres7feTab1Save,
      "indexSelected": _vm.indexSelected,
      "searchIndex": _vm.searchIndex,
      "receivedHres7feDetail": _vm.receivedHres7feDetail
    }
  }), _vm._v(" "), _c('detail-tab2', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "detailTab2": _vm.detail.tab2,
      "searchIndex": _vm.searchIndex,
      "indexSelected": _vm.indexSelected,
      "postHres7feTab2Save": _vm.postHres7feTab2Save
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e7edf30e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7fe/detail.vue
// module id = 4005
// module chunks = 1